import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const REALCSPConfig = {
  cspConfiguration: {
    partner: 'real',
    partnerTitle: 'REAL Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'real-sit-petportal-auth.petsure.com.au',
        appClientId: 'u31NR0ZSrUdpoidvXs4Jrrsh2TNmqvkB',
        cspMfaUrl: 'https://real-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'real-uat-petportal-auth.petsure.com.au',
        appClientId: 'AeJVIhmZsjuCZkiNtfpRYFSZ0D93yplM',
        cspMfaUrl: 'https://real-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'real-preprod-petportal-auth.petsure.com.au',
        appClientId: 'RfgBiQUJrqunvp0HPIH6q0EzS8ZMfoy3',
        cspMfaUrl: 'https://real-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'real-petportal-auth.petsure.com.au',
        appClientId: 'SwQFlFosPY4hmb2tkDISUvViTB1F4C76',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://real-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'realpetinsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'realpetinsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'realpetinsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'realpetinsurance.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg-real.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg-real.png'
    },
    customFaviconUrl: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/real-favicon.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/real-favicon.png'
    },
    headerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/real-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/real-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/real-footer.png',
        imageTitle: 'REAL Pet Insurance',
        imageTitleDescription: 'REAL Pet Insurance'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/real-footer.png',
        imageTitle: 'REAL Pet Insurance',
        imageTitleDescription: 'REAL Pet Insurance'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: true,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'REAL - Pet Portal Login',
      description:
        'Access your REAL Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
